// extracted by mini-css-extract-plugin
export default {"container":"managed-order-table_container__zkohy","datePicker":"managed-order-table_datePicker__OXTaF"};